
(function () {
  'use strict';

  var STORAGE_KEY = '2lane:wishlist';
  var BUTTONS = '.product-card__wish, [data-wishlist-toggle], .product-buy__wish';
  var listeners = [];

  function handleOf(url) {
    var m = /\/products\/([^\/?#]+)/.exec(String(url || ''));
    if (!m) return '';
    try { return decodeURIComponent(m[1]).toLowerCase(); }
    catch (e) { return m[1].toLowerCase(); }
  }

  function sameProduct(a, b) {
    var numeric = /^\d+$/;
    if (numeric.test(String(a.id)) && numeric.test(String(b.id))) return String(a.id) === String(b.id);
    var ha = handleOf(a.url), hb = handleOf(b.url);
    if (ha && hb) return ha === hb;
    return String(a.id) === String(b.id);
  }

  function matches(item, target) {
    return target && typeof target === 'object'
      ? sameProduct(item, target)
      : String(item.id) === String(target);
  }

  function read() {
    var items = [];
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (raw) items = JSON.parse(raw);
    } catch (e) { /* private mode */ }
    if (!Array.isArray(items)) return [];
    return items.filter(function (item, i) {
      return item && !items.slice(0, i).some(function (prev) { return prev && sameProduct(prev, item); });
    });
  }

  function write(items) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); }
    catch (e) { /* ignore */ }
    listeners.forEach(function (fn) { try { fn(items); } catch (e) {} });
    updateBubbles(items.length);
  }

  var LEGACY_KEY = 'wishlistItem';
  var IMPORTED_KEY = '2lane:wishlist-imported';
  var IMPORT_MAX = 100;
  var FILL_BATCH = 12;

  function isHandle(value) {
    return typeof value === 'string' && /^[^\s\/?#%\\]{1,255}$/.test(value);
  }

  function legacyHandles() {
    var raw;
    try { raw = JSON.parse(localStorage.getItem(LEGACY_KEY)); }
    catch (e) { return []; }
    return Array.isArray(raw) ? raw.filter(isHandle) : [];
  }

  function importLegacy() {
    try {
      if (localStorage.getItem(IMPORTED_KEY)) return;
      if (!read().length) {
        var now = Date.now();
        var items = legacyHandles().slice(-IMPORT_MAX).reverse().map(function (handle, i) {
          var title = handle.replace(/[-_]+/g, ' ').trim();
          return {
            id: handle,
            title: title ? title.charAt(0).toUpperCase() + title.slice(1) : 'Saved product',
            image: '',
            url: '/products/' + handle,
            price: '',
            priceLabel: '',
            addedAt: now - i,
            imported: true
          };
        });
        if (items.length) localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      }
      localStorage.setItem(IMPORTED_KEY, '1');
    } catch (e) { /* private mode, or storage is full */ }
  }

  function priceLabelFor(product) {
    var cents = Number(product.price);
    if (!isFinite(cents)) return '';
    var label = window.TwoLaneCart && window.TwoLaneCart.formatMoney
      ? window.TwoLaneCart.formatMoney(cents)
      : '$' + (cents / 100).toFixed(2);
    return product.price_varies ? 'From ' + label : label;
  }

  function fillImported() {
    if (!window.fetch || !window.Promise) return;
    var asked = Object.create(null);

    function next() {
      var batch = [];
      read().forEach(function (item) {
        var handle = String(item.id);
        if (item.imported !== true || asked[handle] || !isHandle(handle)) return;
        if (batch.length >= FILL_BATCH) return;
        asked[handle] = true;
        batch.push(handle);
      });
      if (!batch.length) return;

      Promise.all(batch.map(function (handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
          .then(function (r) {
            if (r.ok) return r.json();
            return r.status === 404 ? false : null;
          })
          .then(function (product) {
            if (product === false) return false;
            return product && product.id && typeof product.title === 'string' ? product : null;
          })
          .catch(function () { return null; });
      })).then(function (products) {
        var found = Object.create(null);
        batch.forEach(function (handle, i) { found[handle] = products[i]; });

        var changed = false;
        var items = read().map(function (item) {
          var handle = String(item.id);
          if (item.imported !== true || !(handle in found)) return item;
          var product = found[handle];
          if (product === null) return item;
          changed = true;
          if (product === false) return null;
          var image = typeof product.featured_image === 'string' ? product.featured_image : '';
          return {
            id: String(product.id),
            title: product.title,
            image: image.replace(/(\.[a-z]+)(\?.*)?$/i, '_600x$1$2'),
            url: '/products/' + handle,
            price: String(product.price),
            priceLabel: priceLabelFor(product),
            addedAt: item.addedAt
          };
        }).filter(Boolean);

        if (changed) write(items);
        if (products.indexOf(null) === -1) next();
      });
    }

    next();
  }

  function slug(str) {
    return String(str || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '')
      .slice(0, 64);
  }

  function cardPayload(btn) {
    var card = btn.closest('[data-product-card], .product-card');
    var titleEl = card && card.querySelector('.product-card__name');
    var imgEl = card && card.querySelector('.product-card__img');
    var linkEl = card && (card.querySelector('a.product-card__name') || card.querySelector('.product-card__img-wrap a'));
    var priceEl = card && card.querySelector('.product-card__price, [data-price-display]');

    var title = (card && card.dataset.productTitle) || (titleEl && titleEl.textContent.trim()) || btn.dataset.title || 'Saved product';
    var id = (card && (card.dataset.productId || card.dataset.productHandle)) ||
             btn.dataset.productId ||
             slug(title);

    var image = (card && card.dataset.image) || (imgEl && (imgEl.currentSrc || imgEl.src)) || btn.dataset.image || '';
    var url = (card && card.dataset.url) || (linkEl && linkEl.getAttribute('href')) || btn.dataset.url || '';
    var price = (card && card.dataset.price) || btn.dataset.price || '';
    var priceLabel = priceEl ? priceEl.textContent.trim().replace(/\s+/g, ' ') : '';

    if (!card && document.querySelector('[data-product-title], .product-info__title, h1.product__title, .product-buy')) {
      var h1 = document.querySelector('.product-info__title, h1.product__title, [data-product-title], .product-buy h1, main h1');
      if (h1 && !btn.dataset.title) title = h1.textContent.trim();
      id = btn.dataset.productId || handleOf(window.location.pathname) || slug(title);
      var hero = document.querySelector('.product-gallery__main, .product-gallery__img, .product-media img, [data-product-image]');
      if (btn.dataset.image) image = btn.dataset.image;
      else if (hero) image = hero.currentSrc || hero.src;
      var buyPrice = document.querySelector('[data-price], .product-price__current, .price');
      if (buyPrice) priceLabel = buyPrice.textContent.trim().replace(/\s+/g, ' ');
      url = btn.dataset.url || window.location.pathname || '/';
    }

    return {
      id: String(id),
      title: title,
      image: image,
      url: url,
      price: price,
      priceLabel: priceLabel,
      addedAt: Date.now()
    };
  }

  function has(target) {
    return read().some(function (item) { return matches(item, target); });
  }

  function add(item) {
    var items = read().filter(function (i) { return !sameProduct(i, item); });
    items.unshift(item);
    write(items);
    return items;
  }

  function remove(target) {
    var items = read().filter(function (i) { return !matches(i, target); });
    write(items);
    return items;
  }

  function toggle(btn) {
    var item = cardPayload(btn);
    if (has(item)) {
      remove(item);
      btn.classList.remove('is-wished');
      btn.setAttribute('aria-label', 'Add to wishlist');
      toast('Removed from wishlist');
    } else {
      add(item);
      btn.classList.add('is-wished');
      btn.setAttribute('aria-label', 'Remove from wishlist');
      toast('Saved to wishlist');
    }
    syncButtons();
  }

  function syncButtons(roots) {
    var items = read();
    var scopes = roots && roots.length ? Array.prototype.slice.call(roots) : [document];

    scopes.forEach(function (scope) {
      if (!scope || !scope.querySelectorAll) return;
      scope.querySelectorAll(BUTTONS).forEach(function (btn) {
        var payload = cardPayload(btn);
        var on = items.some(function (i) { return sameProduct(i, payload); });
        btn.classList.toggle('is-wished', on);
        btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
        btn.dataset.productId = payload.id;
      });
    });
  }

  function updateBubbles(count) {
    document.querySelectorAll('[data-wishlist-bubble]').forEach(function (el) {
      el.textContent = String(count);
      el.hidden = count < 1;
      el.classList.toggle('is-visible', count > 0);
    });
  }

  function toast(message) {
    var existing = document.querySelector('.wishlist-toast');
    if (existing) existing.remove();
    var el = document.createElement('div');
    el.className = 'wishlist-toast';
    el.setAttribute('role', 'status');
    el.textContent = message;
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.remove(); }, 280);
    }, 1800);
  }

  function money(item) {
    if (item.priceLabel) return item.priceLabel;
    if (item.price && !isNaN(Number(item.price))) {
      var n = Number(item.price);
      if (n > 1000) n = n / 100;
      return '$' + n.toFixed(2);
    }
    return '';
  }

  function renderPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    var empty = document.querySelector('[data-wishlist-empty]');
    var countEl = document.querySelector('[data-wishlist-count]');
    if (!grid) return;

    var items = read();
    if (countEl) countEl.textContent = String(items.length);

    if (!items.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;
    grid.innerHTML = items.map(function (item) {
      var price = money(item);
      var href = /^\/(?!\/)/.test(String(item.url || '')) ? item.url : '#';
      return (
        '<article class="wishlist-card" data-wishlist-id="' + escapeAttr(item.id) + '">' +
          '<a class="wishlist-card__media" href="' + escapeAttr(href) + '">' +
            (item.image
              ? '<img src="' + escapeAttr(item.image) + '" alt="' + escapeAttr(item.title) + '" loading="lazy" />'
              : '<span class="wishlist-card__placeholder">No image</span>') +
          '</a>' +
          '<div class="wishlist-card__body">' +
            '<h2 class="wishlist-card__title"><a href="' + escapeAttr(href) + '">' + escapeHtml(item.title) + '</a></h2>' +
            (price ? '<p class="wishlist-card__price">' + escapeHtml(price) + '</p>' : '') +
            '<div class="wishlist-card__actions">' +
              '<a class="wishlist-card__shop" href="' + escapeAttr(href) + '">View product</a>' +
              '<button type="button" class="wishlist-card__remove" data-wishlist-remove="' + escapeAttr(item.id) + '">Remove</button>' +
            '</div>' +
          '</div>' +
        '</article>'
      );
    }).join('');
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(str) {
    return escapeHtml(str).replace(/'/g, '&#39;');
  }

  function init() {
    importLegacy();
    updateBubbles(read().length);
    syncButtons();
    renderPage();

    document.addEventListener('theme:products-appended', function (e) {
      var cards = e.detail && e.detail.cards;
      syncButtons(cards && cards.length ? cards : null);
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest(BUTTONS);
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        toggle(btn);
        return;
      }

      var remove = e.target.closest('[data-wishlist-remove]');
      if (remove) {
        removeItem(remove.dataset.wishlistRemove);
        renderPage();
        syncButtons();
        toast('Removed from wishlist');
      }
    });

    listeners.push(function () {
      renderPage();
      syncButtons();
    });

    if (document.querySelector('[data-wishlist-grid]') || document.readyState === 'complete') {
      fillImported();
    } else {
      window.addEventListener('load', fillImported);
    }
  }

  function removeItem(id) { remove(id); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.TwoLaneWishlist = {
    get items() { return read(); },
    has: has,
    add: add,
    remove: remove,
    sync: syncButtons
  };

})();
